export default __webpack_public_path__ + "static/media/Normas.a73cad53.jpg";